import React from "react";
import { Button } from "@creditonebank/c1b-components";
import { ReactComponent as BadgeIcon } from "../../assets/BadgeIcon.svg";


const SignOut = () => {

    const signInWidget = (() => {
        window.location.replace("/")
    })

    return (
        <div className="bg">
            <div className="session-timeout-popup-container">
                <div className="popup-content-container-signout">
                    <div className="timer-box">
                        <BadgeIcon className="badge" />
                        <h4>You've been securely <br /> signed out</h4>
                    </div>
                    <div className="buttons-session-timed-out">
                        <Button icon="lock" onClick={signInWidget} className="sign-in">Sign in</Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SignOut